var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackGoldbarCartOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50533 4.69779L3.50499 4.69744L3.50328 4.69639L3.50533 4.69779ZM10 3.59474L9.24635 1.54811L6.50697 0.0195312L0.830146 3.1254L0 5.40197L3.34654 7.22953L3.40152 4.75247L0.798047 3.2267L1.02138 3.34798L0.894004 3.27262L1.34886 3.52078L0.934982 3.27262L3.50499 4.69744L9.03872 1.76157L8.15292 2.26069L9.19 1.71705L7.13735 2.83273L3.57431 4.8401L3.3462 7.22918L9.99966 3.59404L10 3.59474ZM3.61597 3.9831L2.1172 3.16221L3.57499 3.62488L8.03818 1.59192L3.61597 3.9831Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackGoldbarCartOrder);
export default __webpack_public_path__ + "static/media/BlackGoldbarCartOrder.3bba9c6be31374aba00ba1b4cf04c4e6.svg";
export { ForwardRef as ReactComponent };